import { useState } from 'react'

export const ExpandableSection = ({
  title,
  content,
  isList = false,
}: {
  title: string
  content: string | string[]
  isList?: boolean
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const needsTruncation =
    typeof content === 'string' ? content.length > 150 : content.length > 3

  const collapsedHeight = isList ? '110px' : '75px'

  return (
    <div className='mt-12 p-6 rounded-xl shadow-sm' style={{ backgroundColor: 'var(--card-bg)' }}>
      <h2 className='text-2xl font-semibold mb-4' style={{ color: 'var(--text-primary)' }}>{title}</h2>
      <div
        className='overflow-hidden transition-all duration-500 ease-in-out'
        style={{ maxHeight: isExpanded ? '2000px' : collapsedHeight }}
      >
        {isList && Array.isArray(content) ? (
          <ul className='list-disc list-inside space-y-2 pr-4'>
            {content.map((item, index) => (
              <li key={index} className='leading-relaxed' style={{ color: 'var(--text-secondary)' }}>
                {item}
              </li>
            ))}
          </ul>
        ) : (
          <p className='leading-relaxed text-base font-medium' style={{ color: 'var(--text-secondary)', whiteSpace: 'pre-line' }}>
            {content}
          </p>
        )}
      </div>
      {needsTruncation && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className='mt-3 text-sm font-semibold hover:underline focus:outline-none'
          style={{ color: 'var(--accent-primary)' }}
        >
          {isExpanded ? 'بستن' : 'ادامه مطلب...'}
        </button>
      )}
    </div>
  )
}
